var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0047 5.59437V4H15.4103V5.59437H8.99531V4H7.40094V5.59437H6.59437C6.1567 5.59437 5.78156 5.75068 5.46893 6.06331C5.15631 6.37593 5 6.75732 5 7.2075V18.4056C5 18.8433 5.15631 19.2184 5.46893 19.5311C5.78156 19.8437 6.1567 20 6.59437 20H17.8113C18.2489 20 18.6241 19.8437 18.9367 19.5311C19.2493 19.2184 19.4056 18.8433 19.4056 18.4056V7.2075C19.4056 6.75732 19.2493 6.37593 18.9367 6.06331C18.6241 5.75068 18.2489 5.59437 17.8113 5.59437H17.0047ZM17.8113 18.4056H6.59437V9.60844H17.8113V18.4056ZM8.2075 15.1981H12.2028V11.2028H8.2075V15.1981Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.57c6383aa2ac47e37a7565011909dbf7.svg";
export { ForwardRef as ReactComponent };